module.exports = "<span class=\"tsz-notification-badge-total warn\" ng-show=$ctrl.total>{{$ctrl.total}}</span> <span class=\"tsz-notification-badge-total ok\" ng-show=\"!$ctrl.total && !$ctrl.hideWhenOk\">&#10003;</span> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/tsz-notification-badge/tsz-notification-badge.html
// module id = 136
// module chunks = 1